// Standard currency formats: https://help.shopify.com/en/manual/payments/currency-formatting
// Replaces the former currency helper, which only supported four of these eight placeholders.
// placeholder => [precision, thousands separator, decimal separator]
const PLACEHOLDERS = {
    amount: [2, ',', '.'],                                  // 1,134.65
    amount_no_decimals: [0, ',', '.'],                      // 1,135
    amount_with_comma_separator: [2, '.', ','],             // 1.134,65
    amount_no_decimals_with_comma_separator: [0, '.', ','], // 1.135
    amount_with_apostrophe_separator: [2, "'", '.'],        // 1'134.65
    amount_no_decimals_with_space_separator: [0, ' ', ''],  // 1 135
    amount_with_space_separator: [2, ' ', ','],             // 1 134,65
    amount_with_period_and_space_separator: [2, ' ', '.'],  // 1 134.65
};

const PLACEHOLDER_REGEX = /\{\{\s*(\w+)\s*\}\}/;
const DEFAULT_FORMAT = '{{amount}}';

const shopMoney = () => window.shopMoney ?? {};

const formatWithDelimiters = (cents, precision, thousands, decimal) => {
    if (isNaN(cents) || cents === null) {
        return '0';
    }

    const parts = (cents / 100.0).toFixed(precision).split('.');
    const amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);

    return parts[1] ? amount + decimal + parts[1] : amount;
};

// Standard currency formats: https://help.shopify.com/en/manual/payments/currency-formatting
// precision overrides the decimals of the format placeholder (used for money_without_trailing_zeros)
export const formatMoney = (money, format = shopMoney().moneyFormat, precision = null) => {
    if (typeof money === 'string') {
        money = money.replace('.', '');
    }

    const formatString = format || DEFAULT_FORMAT;
    const placeholder = formatString.match(PLACEHOLDER_REGEX);
    // Unknown placeholders fall back to the default separators instead of rendering nothing.
    const [defaultPrecision, thousands, decimal] = PLACEHOLDERS[placeholder?.[1]] ?? PLACEHOLDERS.amount;
    const amount = formatWithDelimiters(money, precision ?? defaultPrecision, thousands, decimal);

    return placeholder ? formatString.replace(PLACEHOLDER_REGEX, () => amount) : amount;
};

// Implements Liquid filters: https://shopify.dev/docs/api/liquid/filters/money-filters
export const moneyFilter = (money, filter) => {
    switch (filter) {
        case 'money_with_currency':
            return formatMoney(money, shopMoney().moneyWithCurrencyFormat);
        case 'money_without_currency':
            // Keep the placeholder only, dropping the currency symbol/code wherever the format puts it.
            return formatMoney(money, (shopMoney().moneyFormat ?? '').match(PLACEHOLDER_REGEX)?.[0]);
        case 'money_without_trailing_zeros':
            // Only remove trailing zeros if money is a whole number.
            return formatMoney(money, shopMoney().moneyFormat, Math.round(money) % 100 === 0 ? 0 : null);
        default:
            return formatMoney(money);
    }
};
